import React from "react";
import { Text, useMediaQuery } from "@chakra-ui/react";
import { type Integration, type IntegrationSimple } from "lib/sanity";
import { Section } from "components/section";
import { chunk } from "lodash";
import { TextTitle } from "ui/text";
import { integrationsCount, sourcesCount } from "../../../constants/integrations";
import { XtoYLinkSlider } from "../x-y-link-slider";

type PaginatedLinksProps = {
  primaryIntegration: Integration;
  allIntegrations: IntegrationSimple[];
  variant: "allDestinations" | "allSources";
};

function PaginatedLinks({ primaryIntegration, allIntegrations, variant }: PaginatedLinksProps) {
  const [isMobile] = useMediaQuery("(max-width: 800px)");
  const destinationChunks = chunk(allIntegrations, 10);

  return (
    <Section bg="new.blue.50">
      <TextTitle
        size="lg"
        title={
          <>
            All {variant === "allDestinations" ? integrationsCount : sourcesCount}+{" "}
            <Text as="span" color="new.blue.700">
              {primaryIntegration.name}
            </Text>{" "}
            integrations
          </>
        }
        mb={{ base: "big", md: "bigger" }}
      />

      <XtoYLinkSlider
        variant={variant}
        primaryIntegration={primaryIntegration}
        integrationChunks={destinationChunks}
        slidesPerView={isMobile ? 1 : 3}
      />
    </Section>
  );
}

export default PaginatedLinks;
